import { VendorActionTypes } from './constants';

export const getVendors = (payload: any) => ({
    type: VendorActionTypes.GET_VENDORS,
    payload,
});

export const getVendorByIdAction = (vendorId: number | string) => ({
    type: VendorActionTypes.GET_VENDOR_BY_ID,
    payload: vendorId,
});

export const addVendor = (payload: any) => ({
    type: VendorActionTypes.ADD_VENDOR,
    payload,
});

export const updateVendorByIdAction = (payload: any) => ({
    type: VendorActionTypes.UPDATE_VENDOR,
    payload,
});

export const deleteVendorByIdAction = (vendorId: number) => ({
    type: VendorActionTypes.DELETE_VENDOR,
    payload: vendorId,
});

export const resetVendor = () => ({
    type: VendorActionTypes.RESET,
});

export const bulkImportVendors = (vendors: any[]) => ({
    type: VendorActionTypes.BULK_IMPORT_VENDORS,
    payload: { vendors },
});

export const resetVendorImportState = () => ({
    type: VendorActionTypes.RESET_IMPORT_STATE,
    payload: {},
});

export const vendorApiResponseSuccess = (actionType: string, data: any) => ({
    type: VendorActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const vendorApiResponseError = (actionType: string, error: any) => ({
    type: VendorActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});